export enum KB_PAY_CUSTOM_SCHEME {
  EXTERNAL_PREFIX = 'external',
  KB_APP_PREFIX = 'kbpay-liivmate://',
}

export enum KB_PAY_CUSTOM_SEARCH_PARAMS {
  KB_ID = 'reqParam',
  IOS_PARAMS = 'params',
  REDIRECT_URL = 'redirectUrl',
}
